/*
 * Copyright (c) 2020 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */

import React from "react";
import {DIYOperationStatus, withStatus} from '../../common/DIYStatusPage';
import Summary from "./Summary";
import {IGatewayRegistrationSummaryProps} from "../../../stores/GatewayManager/IGatewayRegistrationInterfaces";
import {Button} from "@scuf/common";
import './RegistrationStatus.scss';

/**
 * The properties for the registration component
 */
export interface IRegistrationStatusProps extends IGatewayRegistrationSummaryProps {
  /**
   * The status of the registration operation
   */
  isSuccess: boolean;

  /**
   * A custom message about the status
   */
  message?: string;

  /**
   * The callback handler when user wants to navigate to support page.
   */
  onContactSupport: () => void;

  /**
   * The callback handler for the registration retry
   */
  onRetry?: () => void;
}

/**
 * The status of the registration summary
 */
export default class RegistrationStatus extends React.Component<IRegistrationStatusProps> {
  /**
   * Render the registration status component
   */
  render() {
    let elements: JSX.Element[] = [];
    let regStatus = this.props.isSuccess;
    let status = regStatus ? DIYOperationStatus.SUCCESS : DIYOperationStatus.IMPORTANT;
    let title = (regStatus) ? RegistrationStatus.REGISTRATION_SUCCESS_TITLE : RegistrationStatus.REGISTRATION_FAILURE_TITLE;
    const StatusWrappedSummary = withStatus(Summary);
    elements.push(
      <div className={`application-page-content ui-gw-reg-status`}>
        <StatusWrappedSummary title={title}
                              epName={this.props.epName}
                              message={this.getMessage()}
                              serialNumber={this.props.serialNumber}
                              registeredSite={this.props.registeredSite}
                              status={status}
                              onContactSupport={this.props.onContactSupport}/>
      </div>
    );
    // Provide a Retry option if registration failed
    elements.push(
      <div className='application-navigation ui-box-shadow'>
        <div className='ui-gw-reg-status-navigation'>
          <Button className='ui-gw-reg-nav-cnt-sprt' type="primary"
                  onClick={() => {
                    this.props.onContactSupport();
                  }}
                  disabled={false}
                  content="Contact Support"/>
          
          {
            (!regStatus) ? <Button className='ui-gw-reg-nav-retry' type="secondary"
                                   onClick={() => {
                                     this.props.onRetry!();
                                   }}
                                   disabled={false}
                                   content="Retry"/> : <></>
          }
        
        </div>
      </div>
    );
    return elements;
  }

  /**
   * Get the status message for registration
   * @returns {string}
   */
  private getMessage() {
    if (!!this.props.message) {
      return this.props.message;
    }
    let regStatus = this.props.isSuccess;
    return (regStatus) ? RegistrationStatus.SUMMARY_MESSAGE_SUCCESS : RegistrationStatus.SUMMARY_MESSAGE_ERROR;
  }

  public static readonly REGISTRATION_SUCCESS_TITLE = "Setup Complete";

  public static readonly REGISTRATION_FAILURE_TITLE = "Setup Incomplete";

  public static readonly SUMMARY_MESSAGE_ERROR = 'Unable to register.';

  public static readonly REGISTRATION_PRECONDITIONS_FAILED = 'One or more of preconditions failed. The gateway is applicable only' +
    ' for Forge Connect sites and should be not be associated with more than a single site.';

  public static readonly SUMMARY_MESSAGE_SUCCESS = 'Our team has been notified of the next steps.Once we complete these steps, we will inform you' +
    ' when you can start using Honeywell Forge';

}
